/**
 * Shared Sentry tracesSampler — single source of truth for all three
 * Sentry config files (client, edge, server).
 *
 * 10% baseline sampling. Sentry sampling decisions happen before
 * request duration is known, so duration-based adaptive sampling
 * is not possible here. Slow-request observability is handled by
 * Server-Timing headers and PostHog timing events (inbox_page_interactive,
 * case_panel_loaded).
 */
export function tracesSampler(samplingContext: { parentSampled?: boolean }): boolean | number {
  // Respect parent sampling decision for distributed traces
  if (samplingContext.parentSampled !== undefined) {
    return samplingContext.parentSampled;
  }
  return 0.1;
}
